import { UserRole } from '@lombok/shared';
import { Button } from '@lombok/ui';
import { useSessionProfile } from '@/auth/useSessionProfile';
import { useRepeatOrder } from './useRepeatOrder';

/** "Repetir pedido" on an order's detail, shown to the customer only. */
export function RepeatOrderButton({ orderId }: { orderId: string }) {
  const { profile } = useSessionProfile();
  const { repeat, pendingId, error } = useRepeatOrder();
  if (profile?.role !== UserRole.CUSTOMER_USER) return null;

  return (
    <div className="flex flex-col items-end gap-1">
      <Button size="sm" variant="outline" onClick={() => void repeat(orderId)} disabled={pendingId !== null}>
        {pendingId === orderId ? 'Cargando…' : 'Repetir pedido'}
      </Button>
      {error ? (
        <p role="alert" className="max-w-xs text-right text-xs text-danger">
          {error}
        </p>
      ) : null}
    </div>
  );
}
